import React from "react";
import heroimg from "../../../assets/image/Asset1.png";
import WhatYouGainSection from "../Components/UI/WhatYouGainSection";
import "../Components/UI/style.css";
import claim from "../../../assets/image/claim.png";
import book from "../../../assets/image/books.png";

import { NewNavbar } from "../Pages/NewNavbar";

import Marquee from "react-fast-marquee";

import gift from "../../../assets/image/gift.png";
import Footer from "../Footer";
import { Link } from "react-router-dom";

export default function BuyWithMilford() {
  const infoCards = [
    {
      title: "Step-By-Step Guidance",
      desc: "Navigate the entire home buying process with ease.",
      icon: "/icon3/icon1.png",
    },
    {
      title: "Financial Strategies",
      desc: "Determine a realistic budget and secure financing for your new home by securing the best mortgage.",
      icon: "/icon3/icon2.png",
    },
    {
      title: "Negotiation Tips",
      desc: "Gain confidence in negotiating the best terms and craft compelling offers that stand out to sellers.",
      icon: "/icon3/icon3.png",
    },
    {
      title: "Contract Essentials",
      desc: "Understand contracts and obligations.",
      icon: "/icon3/icon4.png",
    },
    {
      title: "Home Inspections and Appraisals",
      desc: "Discover the critical role of inspections and appraisals, and how to navigate each step with confidence.",
      icon: "/icon3/icon5.png",
    },
    {
      title: "Avoiding Pitfalls",
      desc: "Identify common mistakes and how to avoid them.",
      icon: "/icon3/icon6.png",
    },
  ];
  const options = {
    loop: true,
    margin: 10,
    items: 1,
    navigation: true,
    dots: true,
    autoplay: true,
  };
  const options1 = {
    loop: true,
    margin: 20,
    items: 4,
    navigation: true,
    dots: true,
    autoplay: true,
  };

  return (
    <>
      <NewNavbar buySellActive={false} />
      <div className="hero-banner">
        <img
          src={heroimg}
          className="w-100 img-fluid"
          alt="transform your future"
        />
      </div>
      <section className="dream-section">
        <div className="container">
          <p className="vs-title">Your Dream Home Starts Here</p>
          <p className="vs-desc">
            At Milford Real Estate, we're committed to turning your dream home a
            reality. Whether you're a first-time buyer or a seasoned investor,
            our free Home Buying Guide provides the tools and knowledge you need
            to make informed, empowered decisions.
          </p>
          <div className="row align-items-center pt-4">
            <div className="col-lg-4">
              <ul>
                <li>Step-by-step process</li>
                <li>Financial planning strategies</li>
                <li>Negotiation tips</li>
                <li>Insider insights & more</li>
              </ul>
            </div>
            <div className="col-lg-8 ">
              <img src={book} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="">
            <h3 className="vs-title-2 dream-cta">Ready to dive in?</h3>
            <div className="free-buide-btn d-flex gap-5 justify-content-center ">
              <button className="card-btn">
                <Link to={"/buy/buyer-guide/"}>DOWNLOAD YOUR FREE GUIDE</Link>
              </button>
              <button className="card-btn">
                <Link to={"/property-list"}>BROWSE AVAILABLE HOMES</Link>
              </button>
            </div>
          </div>
          <div className="cta-section container">
            <div className="cta">
              <h4>CONFIDENCE STARTS HERE</h4>
              <h1>
                You can trust Milford Real Estate to empower your home buying
                decisions.
              </h1>
            </div>
          </div>
        </div>
        <div className="early vs-early">
          <Marquee className="example-left">
            Belong Inspire Clarity Confidence Success
            <span>Welcome</span>
          </Marquee>
        </div>
      </section>

      <WhatYouGainSection
        bookSrc={claim}
        bottomSection={true}
        infoCard={infoCards}
        title={"What You’ll Gain from This Exclusive Guide"}
        subtitle={"PLAN. BUY. SUCCEED."}
        topIcon={gift}
        customClass={"col-lg-4 col-md-6 "}
        path={"/buy/buyer-guide/"}
      />

      <Footer />
    </>
  );
}
